import { useQuery } from '@tanstack/react-query';
import { fetchStoryApi } from 'apis/common/fetchDropApi';
import { IDropListProps } from 'utils/types/common';
/**
 * * 제외 문화권 쿼리
 */

function useExceptionCultureDropQuery() {
  const { status, data, error, isFetching } = useQuery(
    ['exceptionCultureDropList'],
    async () => fetchStoryApi.exceptionCultureList(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: v.code_name,
          }),
        );
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useExceptionCultureDropQuery;
